var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIosDownloadQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1269_4257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 0H0V116H116V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 6.27002H31.3594V9.40515H34.4945V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 6.27002H34.4922V9.40515H37.6273V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 6.27002H37.625V9.40515H40.7601V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 6.27002H40.7656V9.40515H43.9008V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 6.27002H47.0312V9.40515H50.1664V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 6.27002H50.1641V9.40515H53.2992V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 6.27002H62.7031V9.40515H65.8383V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 6.27002H68.9766V9.40515H72.1117V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 6.27002H75.25V9.40515H78.3851V6.27002Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 9.40527H34.4922V12.5404H37.6273V9.40527Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 9.40527H37.625V12.5404H40.7601V9.40527Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 9.40527H40.7656V12.5404H43.9008V9.40527Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 9.40527H56.4375V12.5404H59.5726V9.40527Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 9.40527H62.7031V12.5404H65.8383V9.40527Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 9.40527H75.25V12.5404H78.3851V9.40527Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 12.54H31.3594V15.6752H34.4945V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 12.5403H34.4922V15.6754H37.6273V12.5403Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 12.54H40.7656V15.6752H43.9008V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 12.54H47.0312V15.6752H50.1664V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 12.54H53.2969V15.6752H56.432V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 12.54H56.4375V15.6752H59.5726V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 12.5403H59.5703V15.6754H62.7054V12.5403Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2445 12.54H72.1094V15.6752H75.2445V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 12.54H75.25V15.6752H78.3851V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 12.54H81.5156V15.6752H84.6508V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 15.6755H43.8906V18.8107H47.0258V15.6755Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 15.6753H59.5703V18.8104H62.7054V15.6753Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 15.6755H62.7031V18.8107H65.8383V15.6755Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 15.6755H65.8438V18.8107H68.9789V15.6755Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2445 15.6755H72.1094V18.8107H75.2445V15.6755Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 15.6755H75.25V18.8107H78.3851V15.6755Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 15.6755H78.3828V18.8107H81.5179V15.6755Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 18.8103H40.7656V21.9454H43.9008V18.8103Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 18.8103H43.8906V21.9454H47.0258V18.8103Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 18.8103H47.0312V21.9454H50.1664V18.8103Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 18.8103H53.2969V21.9454H56.432V18.8103Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 18.8103H62.7031V21.9454H65.8383V18.8103Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 18.8105H68.9766V21.9457H72.1117V18.8105Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2445 18.8103H72.1094V21.9454H75.2445V18.8103Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 18.8103H75.25V21.9454H78.3851V18.8103Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 21.9458H31.3594V25.0809H34.4945V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 21.9458H40.7656V25.0809H43.9008V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 21.9458H43.8906V25.0809H47.0258V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 21.9458H50.1641V25.0809H53.2992V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 21.9458H53.2969V25.0809H56.432V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 21.9458H59.5703V25.0809H62.7054V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 21.9458H62.7031V25.0809H65.8383V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 21.9458H68.9766V25.0809H72.1117V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2445 21.9458H72.1094V25.0809H75.2445V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 21.9458H81.5156V25.0809H84.6508V21.9458Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 25.0811H31.3594V28.2162H34.4945V25.0811Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 25.0811H37.625V28.2162H40.7601V25.0811Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 25.0811H43.8906V28.2162H47.0258V25.0811Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 25.0811H50.1641V28.2162H53.2992V25.0811Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 25.0811H56.4375V28.2162H59.5726V25.0811Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 25.0811H62.7031V28.2162H65.8383V25.0811Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 25.0808H68.9766V28.2159H72.1117V25.0808Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 25.0811H75.25V28.2162H78.3851V25.0811Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 25.0811H81.5156V28.2162H84.6508V25.0811Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 28.2158H37.625V31.351H40.7601V28.2158Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 28.2158H53.2969V31.351H56.432V28.2158Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 28.2158H56.4375V31.351H59.5726V28.2158Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 28.2158H62.7031V31.351H65.8383V28.2158Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 28.2158H65.8438V31.351H68.9789V28.2158Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 28.2158H75.25V31.351H78.3851V28.2158Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 28.2158H78.3828V31.351H81.5179V28.2158Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 31.3511H6.27344V34.4862H9.40857V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.682 31.3511H12.5469V34.4862H15.682V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 31.3511H25.0781V34.4862H28.2133V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 31.3511H28.2188V34.4862H31.3539V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 31.3511H40.7656V34.4862H43.9008V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 31.3511H43.8906V34.4862H47.0258V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 31.3511H50.1641V34.4862H53.2992V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 31.3511H56.4375V34.4862H59.5726V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 31.3511H65.8438V34.4862H68.9789V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 31.3511H68.9766V34.4862H72.1117V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 31.3511H75.25V34.4862H78.3851V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 31.3511H78.3828V34.4862H81.5179V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 31.3511H81.5156V34.4862H84.6508V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 31.3511H90.9219V34.4862H94.057V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 31.3511H100.328V34.4862H103.463V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 31.3511H106.594V34.4862H109.729V31.3511Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 34.4863H6.27344V37.6215H9.40857V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0883 34.4863H21.9531V37.6215H25.0883V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 34.4863H28.2188V37.6215H31.3539V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 34.4863H37.625V37.6215H40.7601V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 34.4863H40.7656V37.6215H43.9008V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 34.4863H47.0312V37.6215H50.1664V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 34.4863H53.2969V37.6215H56.432V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 34.4863H56.4375V37.6215H59.5726V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 34.4863H59.5703V37.6215H62.7054V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 34.4863H65.8438V37.6215H68.9789V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 34.4863H68.9766V37.6215H72.1117V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 34.4863H78.3828V37.6215H81.5179V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 34.4863H81.5156V37.6215H84.6508V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 34.4863H87.7812V37.6215H90.9164V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 34.4863H97.1875V37.6215H100.323V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 34.4863H106.594V37.6215H109.729V34.4863Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8148 37.6211H15.6797V40.7562H18.8148V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 37.6211H25.0781V40.7562H28.2133V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 37.6211H28.2188V40.7562H31.3539V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 37.6211H31.3594V40.7562H34.4945V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 37.6211H37.625V40.7562H40.7601V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 37.6211H40.7656V40.7562H43.9008V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 37.6211H43.8906V40.7562H47.0258V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 37.6211H53.2969V40.7562H56.432V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 37.6213H59.5703V40.7565H62.7054V37.6213Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 37.6211H62.7031V40.7562H65.8383V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 37.6211H65.8438V40.7562H68.9789V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2445 37.6211H72.1094V40.7562H75.2445V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 37.6211H75.25V40.7562H78.3851V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 37.6211H78.3828V40.7562H81.5179V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7914 37.6211H84.6562V40.7562H87.7914V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 37.6211H87.7812V40.7562H90.9164V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 37.6211H97.1875V40.7562H100.323V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 37.6211H100.328V40.7562H103.463V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 37.6211H106.594V40.7562H109.729V37.6211Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 40.7566H9.40625V43.8917H12.5414V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 40.7566H31.3594V43.8917H34.4945V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 40.7566H34.4922V43.8917H37.6273V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 40.7566H47.0312V43.8917H50.1664V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 40.7566H53.2969V43.8917H56.432V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 40.7566H56.4375V43.8917H59.5726V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 40.7566H62.7031V43.8917H65.8383V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 40.7563H68.9766V43.8915H72.1117V40.7563Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 40.7566H75.25V43.8917H78.3851V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 40.7566H78.3828V43.8917H81.5179V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 40.7566H87.7812V43.8917H90.9164V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 40.7566H90.9219V43.8917H94.057V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 40.7566H94.0547V43.8917H97.1898V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 40.7566H97.1875V43.8917H100.323V40.7566Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 43.8916H6.27344V47.0267H9.40857V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 43.8914H9.40625V47.0265H12.5414V43.8914Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9476 43.8916H18.8125V47.0267H21.9476V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0883 43.8916H21.9531V47.0267H25.0883V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 43.8916H25.0781V47.0267H28.2133V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 43.8916H28.2188V47.0267H31.3539V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 43.8916H37.625V47.0267H40.7601V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 43.8916H40.7656V47.0267H43.9008V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 43.8916H47.0312V47.0267H50.1664V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 43.8916H65.8438V47.0267H68.9789V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 43.8916H81.5156V47.0267H84.6508V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 43.8916H87.7812V47.0267H90.9164V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 43.8916H106.594V47.0267H109.729V43.8916Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 47.0269H6.27344V50.162H9.40857V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 47.0269H9.40625V50.162H12.5414V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 47.0269H31.3594V50.162H34.4945V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 47.0269H37.625V50.162H40.7601V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 47.0269H40.7656V50.162H43.9008V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 47.0269H43.8906V50.162H47.0258V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 47.0269H65.8438V50.162H68.9789V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2445 47.0269H72.1094V50.162H75.2445V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 47.0269H75.25V50.162H78.3851V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 47.0269H78.3828V50.162H81.5179V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 47.0269H81.5156V50.162H84.6508V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 47.0269H87.7812V50.162H90.9164V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 47.0269H90.9219V50.162H94.057V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 47.0269H97.1875V50.162H100.323V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 47.0269H100.328V50.162H103.463V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.604 47.0269H103.469V50.162H106.604V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 47.0269H106.594V50.162H109.729V47.0269Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 50.1621H9.40625V53.2972H12.5414V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0883 50.1621H21.9531V53.2972H25.0883V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 50.1621H25.0781V53.2972H28.2133V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 50.1621H28.2188V53.2972H31.3539V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 50.1621H34.4922V53.2972H37.6273V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 50.1621H40.7656V53.2972H43.9008V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 50.1621H43.8906V53.2972H47.0258V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 50.1621H50.1641V53.2972H53.2992V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 50.1621H53.2969V53.2972H56.432V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 50.1621H59.5703V53.2972H62.7054V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 50.1621H65.8438V53.2972H68.9789V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 50.1621H78.3828V53.2972H81.5179V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 50.1621H94.0547V53.2972H97.1898V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 50.1621H100.328V53.2972H103.463V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 50.1621H106.594V53.2972H109.729V50.1621Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 53.2971H6.27344V56.4323H9.40857V53.2971Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.682 53.2969H12.5469V56.432H15.682V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9476 53.2969H18.8125V56.432H21.9476V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0883 53.2969H21.9531V56.432H25.0883V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 53.2969H31.3594V56.432H34.4945V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 53.2969H43.8906V56.432H47.0258V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 53.2969H68.9766V56.432H72.1117V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 53.2969H81.5156V56.432H84.6508V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7914 53.2969H84.6562V56.432H87.7914V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 53.2969H87.7812V56.432H90.9164V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 53.2969H97.1875V56.432H100.323V53.2969Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 56.4321H6.27344V59.5673H9.40857V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8148 56.4321H15.6797V59.5673H18.8148V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9476 56.4321H18.8125V59.5673H21.9476V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 56.4321H25.0781V59.5673H28.2133V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 56.4321H28.2188V59.5673H31.3539V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 56.4321H34.4922V59.5673H37.6273V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 56.4321H37.625V59.5673H40.7601V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 56.4321H47.0312V59.5673H50.1664V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 56.4321H50.1641V59.5673H53.2992V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 56.4321H53.2969V59.5673H56.432V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 56.4321H56.4375V59.5673H59.5726V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 56.4321H68.9766V59.5673H72.1117V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 56.4321H81.5156V59.5673H84.6508V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 56.4321H87.7812V59.5673H90.9164V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 56.4321H90.9219V59.5673H94.057V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 56.4321H97.1875V59.5673H100.323V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.604 56.4321H103.469V59.5673H106.604V56.4321Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 59.5674H6.27344V62.7025H9.40857V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 59.5676H9.40625V62.7028H12.5414V59.5676Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8148 59.5674H15.6797V62.7025H18.8148V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 59.5674H28.2188V62.7025H31.3539V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 59.5674H31.3594V62.7025H34.4945V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 59.5676H34.4922V62.7028H37.6273V59.5676Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 59.5674H37.625V62.7025H40.7601V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 59.5674H40.7656V62.7025H43.9008V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 59.5674H47.0312V62.7025H50.1664V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 59.5674H50.1641V62.7025H53.2992V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 59.5674H53.2969V62.7025H56.432V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 59.5674H56.4375V62.7025H59.5726V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 59.5674H59.5703V62.7025H62.7054V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 59.5674H65.8438V62.7025H68.9789V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 59.5674H68.9766V62.7025H72.1117V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 59.5674H78.3828V62.7025H81.5179V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 59.5674H81.5156V62.7025H84.6508V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 59.5674H87.7812V62.7025H90.9164V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 59.5674H97.1875V62.7025H100.323V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.604 59.5674H103.469V62.7025H106.604V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 59.5674H106.594V62.7025H109.729V59.5674Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 62.7024H9.40625V65.8375H12.5414V62.7024Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9476 62.7021H18.8125V65.8373H21.9476V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 62.7021H25.0781V65.8373H28.2133V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 62.7021H28.2188V65.8373H31.3539V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 62.7021H31.3594V65.8373H34.4945V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 62.7024H34.4922V65.8375H37.6273V62.7024Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 62.7021H47.0312V65.8373H50.1664V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 62.7021H50.1641V65.8373H53.2992V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 62.7021H53.2969V65.8373H56.432V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 62.7021H56.4375V65.8373H59.5726V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 62.7021H65.8438V65.8373H68.9789V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 62.7021H75.25V65.8373H78.3851V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 62.7021H78.3828V65.8373H81.5179V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 62.7021H81.5156V65.8373H84.6508V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 62.7021H87.7812V65.8373H90.9164V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 62.7021H90.9219V65.8373H94.057V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 62.7021H97.1875V65.8373H100.323V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 62.7021H100.328V65.8373H103.463V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 62.7021H106.594V65.8373H109.729V62.7021Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 65.8376H9.40625V68.9728H12.5414V65.8376Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.682 65.8379H12.5469V68.973H15.682V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8148 65.8379H15.6797V68.973H18.8148V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0883 65.8379H21.9531V68.973H25.0883V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 65.8379H28.2188V68.973H31.3539V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 65.8379H37.625V68.973H40.7601V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 65.8379H40.7656V68.973H43.9008V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 65.8379H43.8906V68.973H47.0258V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 65.8379H47.0312V68.973H50.1664V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 65.8379H56.4375V68.973H59.5726V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 65.8379H65.8438V68.973H68.9789V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 65.8374H68.9766V68.9725H72.1117V65.8374Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 65.8379H75.25V68.973H78.3851V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7914 65.8379H84.6562V68.973H87.7914V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 65.8379H87.7812V68.973H90.9164V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 65.8376H94.0547V68.9728H97.1898V65.8376Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 65.8379H97.1875V68.973H100.323V65.8379Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 68.9727H6.27344V72.1078H9.40857V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 68.9724H9.40625V72.1075H12.5414V68.9724Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 68.9727H25.0781V72.1078H28.2133V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 68.9727H37.625V72.1078H40.7601V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 68.9727H47.0312V72.1078H50.1664V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 68.9727H50.1641V72.1078H53.2992V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 68.9727H56.4375V72.1078H59.5726V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 68.9727H62.7031V72.1078H65.8383V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 68.9727H68.9766V72.1078H72.1117V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 68.9727H87.7812V72.1078H90.9164V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 68.9727H90.9219V72.1078H94.057V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.604 68.9727H103.469V72.1078H106.604V68.9727Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 72.1079H9.40625V75.243H12.5414V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 72.1079H34.4922V75.243H37.6273V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 72.1079H47.0312V75.243H50.1664V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 72.1079H56.4375V75.243H59.5726V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 72.1079H59.5703V75.243H62.7054V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 72.1079H65.8438V75.243H68.9789V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 72.1079H75.25V75.243H78.3851V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 72.1079H78.3828V75.243H81.5179V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 72.1079H87.7812V75.243H90.9164V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 72.1079H90.9219V75.243H94.057V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 72.1079H97.1875V75.243H100.323V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 72.1079H100.328V75.243H103.463V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 72.1079H106.594V75.243H109.729V72.1079Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 75.2429H6.27344V78.3781H9.40857V75.2429Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 75.2432H9.40625V78.3783H12.5414V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 75.2432H25.0781V78.3783H28.2133V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 75.2432H40.7656V78.3783H43.9008V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0258 75.2432H43.8906V78.3783H47.0258V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 75.2432H47.0312V78.3783H50.1664V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 75.2432H50.1641V78.3783H53.2992V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 75.2432H56.4375V78.3783H59.5726V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 75.2432H65.8438V78.3783H68.9789V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 75.2432H75.25V78.3783H78.3851V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 75.2432H78.3828V78.3783H81.5179V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 75.2432H81.5156V78.3783H84.6508V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 75.2432H90.9219V78.3783H94.057V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 75.2432H94.0547V78.3783H97.1898V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 75.2432H97.1875V78.3783H100.323V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 75.2432H100.328V78.3783H103.463V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 75.2432H106.594V78.3783H109.729V75.2432Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.682 78.3779H12.5469V81.5131H15.682V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8148 78.3779H15.6797V81.5131H18.8148V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 78.3779H28.2188V81.5131H31.3539V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 78.3779H34.4922V81.5131H37.6273V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 78.3779H37.625V81.5131H40.7601V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 78.3779H47.0312V81.5131H50.1664V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 78.3779H50.1641V81.5131H53.2992V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 78.3779H53.2969V81.5131H56.432V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 78.3779H56.4375V81.5131H59.5726V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 78.3779H62.7031V81.5131H65.8383V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 78.3779H65.8438V81.5131H68.9789V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 78.3779H75.25V81.5131H78.3851V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 78.3779H81.5156V81.5131H84.6508V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7914 78.3779H84.6562V81.5131H87.7914V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 78.3779H90.9219V81.5131H94.057V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.604 78.3779H103.469V81.5131H106.604V78.3779Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 81.5132H6.27344V84.6483H9.40857V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 81.5132H9.40625V84.6483H12.5414V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.682 81.5132H12.5469V84.6483H15.682V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8148 81.5132H15.6797V84.6483H18.8148V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9476 81.5132H18.8125V84.6483H21.9476V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0883 81.5132H21.9531V84.6483H25.0883V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2133 81.5132H25.0781V84.6483H28.2133V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 81.5132H28.2188V84.6483H31.3539V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 81.5132H40.7656V84.6483H43.9008V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 81.5132H56.4375V84.6483H59.5726V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 81.5132H65.8438V84.6483H68.9789V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 81.5132H68.9766V84.6483H72.1117V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 81.5132H78.3828V84.6483H81.5179V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 81.5132H81.5156V84.6483H84.6508V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7914 81.5132H84.6562V84.6483H87.7914V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 81.5132H87.7812V84.6483H90.9164V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 81.5132H90.9219V84.6483H94.057V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 81.5132H94.0547V84.6483H97.1898V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.604 81.5132H103.469V84.6483H106.604V81.5132Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 84.6484H31.3594V87.7836H34.4945V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 84.6484H37.625V87.7836H40.7601V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 84.6484H47.0312V87.7836H50.1664V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 84.6484H53.2969V87.7836H56.432V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 84.6484H56.4375V87.7836H59.5726V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 84.6484H59.5703V87.7836H62.7054V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 84.6484H62.7031V87.7836H65.8383V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 84.6484H65.8438V87.7836H68.9789V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 84.6484H81.5156V87.7836H84.6508V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 84.6487H94.0547V87.7838H97.1898V84.6487Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 84.6484H106.594V87.7836H109.729V84.6484Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 87.7837H31.3594V90.9188H34.4945V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 87.7834H34.4922V90.9186H37.6273V87.7834Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 87.7837H37.625V90.9188H40.7601V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 87.7837H40.7656V90.9188H43.9008V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 87.7837H47.0312V90.9188H50.1664V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 87.7837H50.1641V90.9188H53.2992V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 87.7837H53.2969V90.9188H56.432V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 87.7837H56.4375V90.9188H59.5726V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7054 87.7837H59.5703V90.9188H62.7054V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 87.7837H65.8438V90.9188H68.9789V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 87.7837H75.25V90.9188H78.3851V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 87.7837H81.5156V90.9188H84.6508V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 87.7837H87.7812V90.9188H90.9164V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 87.7834H94.0547V90.9186H97.1898V87.7834Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 87.7837H97.1875V90.9188H100.323V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 87.7837H100.328V90.9188H103.463V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 87.7837H106.594V90.9188H109.729V87.7837Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 90.9189H37.625V94.0541H40.7601V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 90.9189H47.0312V94.0541H50.1664V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 90.9189H53.2969V94.0541H56.432V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 90.9189H56.4375V94.0541H59.5726V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 90.9189H62.7031V94.0541H65.8383V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 90.9185H68.9766V94.0536H72.1117V90.9185Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 90.9189H75.25V94.0541H78.3851V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 90.9189H78.3828V94.0541H81.5179V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 90.9189H81.5156V94.0541H84.6508V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 90.9187H94.0547V94.0538H97.1898V90.9187Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 90.9189H97.1875V94.0541H100.323V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 90.9189H106.594V94.0541H109.729V90.9189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 94.0537H34.4922V97.1888H37.6273V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 94.0537H37.625V97.1888H40.7601V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 94.0537H47.0312V97.1888H50.1664V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 94.0537H56.4375V97.1888H59.5726V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 94.0537H62.7031V97.1888H65.8383V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 94.0537H68.9766V97.1888H72.1117V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 94.0537H78.3828V97.1888H81.5179V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 94.0537H81.5156V97.1888H84.6508V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7914 94.0537H84.6562V97.1888H87.7914V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 94.0537H87.7812V97.1888H90.9164V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 94.0537H90.9219V97.1888H94.057V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 94.0537H94.0547V97.1888H97.1898V94.0537Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 97.189H34.4922V100.324H37.6273V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 97.189H37.625V100.324H40.7601V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 97.189H50.1641V100.324H53.2992V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 97.189H62.7031V100.324H65.8383V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 97.189H65.8438V100.324H68.9789V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 97.189H68.9766V100.324H72.1117V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2445 97.189H72.1094V100.324H75.2445V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 97.189H81.5156V100.324H84.6508V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 97.189H90.9219V100.324H94.057V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 97.189H94.0547V100.324H97.1898V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 97.189H97.1875V100.324H100.323V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.463 97.189H100.328V100.324H103.463V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.604 97.189H103.469V100.324H106.604V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 97.189H106.594V100.324H109.729V97.189Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 100.324H31.3594V103.459H34.4945V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 100.324H37.625V103.459H40.7601V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 100.324H40.7656V103.459H43.9008V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 100.324H50.1641V103.459H53.2992V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 100.324H53.2969V103.459H56.432V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9789 100.324H65.8438V103.459H68.9789V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7914 100.324H84.6562V103.459H87.7914V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 100.324H90.9219V103.459H94.057V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 100.324H94.0547V103.459H97.1898V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.604 100.324H103.469V103.459H106.604V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 100.324H106.594V103.459H109.729V100.324Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273 103.459H34.4922V106.594H37.6273V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 103.459H37.625V106.594H40.7601V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9008 103.459H40.7656V106.594H43.9008V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 103.459H47.0312V106.594H50.1664V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2992 103.459H50.1641V106.594H53.2992V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8383 103.459H62.7031V106.594H65.8383V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3851 103.459H75.25V106.594H78.3851V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5179 103.459H78.3828V106.594H81.5179V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 103.459H81.5156V106.594H84.6508V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7914 103.459H84.6562V106.594H87.7914V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 103.459H90.9219V106.594H94.057V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 103.459H94.0547V106.594H97.1898V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.323 103.459H97.1875V106.594H100.323V103.459Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4945 106.594H31.3594V109.729H34.4945V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 106.594H37.625V109.729H40.7601V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1664 106.594H47.0312V109.729H50.1664V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.432 106.594H53.2969V109.729H56.432V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5726 106.594H56.4375V109.729H59.5726V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1117 106.594H68.9766V109.729H72.1117V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6508 106.594H81.5156V109.729H84.6508V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9164 106.594H87.7812V109.729H90.9164V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.057 106.594H90.9219V109.729H94.057V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1898 106.594H94.0547V109.73H97.1898V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 106.594H106.594V109.729H109.729V106.594Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9275 6.27002H9.56533H6.27344V9.56191V24.9241V28.216H9.56533H24.9275H28.2194V24.9241V9.56191V6.27002H24.9275ZM24.9275 24.9241H9.56533V9.56191H24.9275V24.9241Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.435 6.27002H91.0731H87.7812V9.56191V24.9241V28.216H91.0731H106.435H109.727V24.9241V9.56191V6.27002H106.435ZM106.435 24.9241H91.0731V9.56191H106.435V24.9241Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9275 87.7834H9.56533H6.27344V91.0753V106.438V109.729H9.56533H24.9275H28.2194V106.438V91.0753V87.7834H24.9275ZM24.9275 106.438H9.56533V91.0753H24.9275V106.438Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9523 12.54H12.5469V21.9454H21.9523V12.54Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46 12.5403H94.0547V21.9457H103.46V12.5403Z",
    fill: "#164375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9523 94.0537H12.5469V103.459H21.9523V94.0537Z",
    fill: "#164375"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1269_4257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosDownloadQr);
export default __webpack_public_path__ + "static/media/ios_download_qr.6082a52cc7e3b0046139fc3a7d40efc8.svg";
export { ForwardRef as ReactComponent };